import { Component, Input, OnInit } from "@angular/core";
import {
  filters,
  ListRelatedRequests,
  lists,
} from "../models/listRelatedRequest";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { CertificatesService } from "src/app/certificates/services/certificates.service";
import { CocService } from "src/app/coc/coc.service";
import { PlacaService } from "src/app/placa/services/placa.service";
import { Certificates } from "src/app/certificates/models/certificatesQuery";
import { CoCcertificates } from "src/app/coc/models/cocCertificatesQuery";
import { Placa } from "src/app/placa/models/placaMailBox";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-list-related-requests",
  templateUrl: "./list-related-requests.component.html",
  styleUrls: ["./list-related-requests.component.scss"],
})
export class ListRelatedRequestsComponent implements OnInit {
  @Input() config: ListRelatedRequests;

  lists: lists = {
    list: [],
    numPagesList: 0,
    numElementsList: 0,
    totalElementsList: 0,
    listLoaded: false,
    listHistory: [],
    numPagesListHistory: 0,
    numElementsListHistory: 0,
    totalElementsListHistory: 0,
    listHistoryLoaded: false,
  };

  filters: filters = {
    filtersTableJSON: null,
    filtersTableHistoryJSON: null,
    filtersTable: "",
    filtersTableHistory: "",
  };

  constructor(
    private sweetAlertService: SweetAlertService,
    private toastrAlertService: ToastrAlertService,
    private certificatesService: CertificatesService,
    private filtersTableStateService: FiltersTableStateService,
    private cocService: CocService,
    private placaService: PlacaService
  ) {}

  ngOnInit(): void {
    this.initFilters();
    this.selectType();
  }

  selectType() {
    switch (this.config.type) {
      case "CERTIFICATES":
        this.getListEnTramiteCertificates(this.filters.filtersTable);
        this.getHistoryListCertificates(this.filters.filtersTableHistory);
        break;
      case "COC":
        this.getListEnTramiteCoC(this.filters.filtersTable);
        this.getHistoryListCoC(this.filters.filtersTableHistory);
        break;
      case "PLACA":
        this.getListEnTramitePlaca(this.filters.filtersTable);
        this.getHistoryListPlaca(this.filters.filtersTableHistory);
        break;
      default:
        break;
    }
  }

  initFilters(): void {
    this.filters.filtersTableJSON =
      this.filtersTableStateService.initFiltersTable(
        "peCreacion",
        ScreenConstants.relatedRequests,
        false
      );
    this.filters.filtersTableHistoryJSON = {
      asc: true,
      order: "peCreacion",
      page: 0,
      size: this.filtersTableStateService.getPersonalSize(),
    };
    this.filters.filtersTable =
      "?_bastidor=" +
      this.config.bastidor +
      "&" +
      this.filtersTableStateService.getString(this.filters.filtersTableJSON);
    this.filters.filtersTableHistory =
      "?_bastidor=" +
      this.config.bastidor +
      "&" +
      this.filtersTableStateService.getString(
        this.filters.filtersTableHistoryJSON
      );
  }

  filterTable(value: any) {
    this.filters.filtersTableJSON = value.filterTableJSON;
    this.filters.filtersTable =
      "?_bastidor=" + this.config.bastidor + "&" + value.filterTableString;
    this.selectType();
  }

  filterTableHistory(value: any) {
    this.filters.filtersTableHistoryJSON = value.filterTableJSON;
    this.filters.filtersTableHistory =
      "?_bastidor=" + this.config.bastidor + "&" + value.filterTableString;
    this.selectType();
  }

  getListEnTramiteCertificates(filtersTable: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService.getQueryListCertificates(filtersTable).subscribe(
      (data) => {
        this.lists.list = data.content.map((e) =>
          Certificates.certificateFromJson(e)
        );
        this.lists.numPagesList = data.totalPages == 0 ? 1 : data.totalPages;
        this.lists.numElementsList = data.numberOfElements;
        this.lists.totalElementsList = data.totalElements;
        this.lists.listLoaded = true;
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getHistoryListCertificates(filtersTableHistory: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService
      .getQueryListHistoryCertificates(filtersTableHistory)
      .subscribe(
        (data) => {
          this.lists.listHistory = data.content.map((e) =>
            Certificates.certificateFromJson(e)
          );
          this.lists.numPagesListHistory =
            data.totalPages == 0 ? 1 : data.totalPages;
          this.lists.numElementsListHistory = data.numberOfElements;
          this.lists.totalElementsListHistory = data.totalElements;
          this.lists.listHistoryLoaded = true;
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  getListEnTramiteCoC(filtersTable: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.cocService.getQueryListCoc(filtersTable).subscribe(
      (data) => {
        this.lists.list = data.content.map((e) =>
          CoCcertificates.cocCertificateFromJson(e)
        );
        this.lists.numPagesList = data.totalPages == 0 ? 1 : data.totalPages;
        this.lists.numElementsList = data.numberOfElements;
        this.lists.totalElementsList = data.totalElements;
        this.lists.listLoaded = true;
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getHistoryListCoC(filtersTableHistory: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.cocService.getQueryListHistoryCoc(filtersTableHistory).subscribe(
      (data) => {
        this.lists.listHistory = data.content.map((e) =>
          CoCcertificates.cocCertificateFromJson(e)
        );
        this.lists.numPagesListHistory =
          data.totalPages == 0 ? 1 : data.totalPages;
        this.lists.numElementsListHistory = data.numberOfElements;
        this.lists.totalElementsListHistory = data.totalElements;
        this.lists.listHistoryLoaded = true;
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getListEnTramitePlaca(filtersTable: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.placaService.getListQuery(filtersTable).subscribe(
      (data) => {
        this.lists.list = data.content.map((e) => Placa.placaFromJson(e));
        this.lists.numPagesList = data.totalPages == 0 ? 1 : data.totalPages;
        this.lists.numElementsList = data.numberOfElements;
        this.lists.totalElementsList = data.totalElements;
        this.lists.listLoaded = true;
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getHistoryListPlaca(filtersTableHistory: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.placaService.getHistorylist(filtersTableHistory).subscribe(
      (data) => {
        this.lists.listHistory = data.content.map((e) =>
          Placa.placaFromJson(e)
        );
        this.lists.numPagesListHistory =
          data.totalPages == 0 ? 1 : data.totalPages;
        this.lists.numElementsListHistory = data.numberOfElements;
        this.lists.totalElementsListHistory = data.totalElements;
        this.lists.listHistoryLoaded = true;
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }
}
